import React from 'react';
import classnames from 'classnames';

export default class ConfigurationOption extends React.Component {
  render() {
    const {active, icon, label, className} = this.props;
    return (
      <div
        className={classnames('configuration-option', className, active ? 'active' : null)}
        onClick={this.props.onClick}>
        <div className="icon-wrapper">{icon}</div>
        <label>{label}</label>
      </div>
    );
  }
}
